import { useRecordContext, useTranslate } from "ra-core";

import { StatusPill } from "../design/StatusPill";
import type { Developer } from "../types";
import { authorizationToSellStatusToPill } from "./authorizationToSellStatus";

/**
 * Renders a developer's `authorization_to_sell_status` as a StatusPill
 * (Almikia design-system.md section 3: binary states always render as a
 * green/red semaforo with icon and text, never color alone). To be used
 * inside a `<DataTable.Col>`, a `<RecordField>`, or anywhere a `Developer`
 * record context is available.
 */
export const AuthorizationToSellStatusPill = () => {
  const record = useRecordContext<Developer>();
  const translate = useTranslate();
  if (!record) return null;

  const { tone, messageKey } = authorizationToSellStatusToPill(
    record.authorization_to_sell_status,
  );

  return (
    <StatusPill
      tone={tone}
      text={
        messageKey
          ? translate(messageKey)
          : String(record.authorization_to_sell_status ?? "—")
      }
    />
  );
};
